import { CSSProperties } from 'react'

export const s = {
  main: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  } as CSSProperties,
  returnText: {
    marginLeft: 4,
    fontWeight: 600,
    fontSize: '16px',
    color: '#1270B8',
  } as CSSProperties,
  autoMargin: { marginLeft: 'auto', marginRight: 'auto' } as CSSProperties,
  absolute: { position: 'absolute', left: 8, top: 8 } as CSSProperties,
  detailsColumn: { display: 'flex', flexDirection: 'column', gap: 16 } as CSSProperties,
}
